export const COMMENTSHEET = {};

//-------------------------------------------------------------------
COMMENTSHEET.UPDATE_PENDING_LIST = "UPDATE_PENDING_LIST";

//-------------------------------------------------------------------
COMMENTSHEET.UPDATE_COM_LIST = "UPDATE_COM_LIST";
//-------------------------------------------------------------------
